import { render, staticRenderFns } from "./LoginIndex.vue?vue&type=template&id=70be851b"
import script from "./LoginIndex.vue?vue&type=script&setup=true&lang=ts"
export * from "./LoginIndex.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports